import { gql } from 'react-apollo';

export const createChurchGroup = gql`
  mutation createChurchGroup($input: CreateChurchGroupInput!) {
    createChurchGroup(input: $input) {
      churchGroup: church_group {
        id
        name
        membersCount: members_count
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/groups/mutations/createChurchGroup.js